import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Clock,
  CircleDollarSign,
  Hourglass,
  CheckCircle2,
  AlertTriangle,
  Ban,
} from 'lucide-react';
import {
  PAYMENT_STATUS_LABELS,
  PAYMENT_STATUS_TONE,
  displayPaymentStatus,
} from '../utils/cobroHelpers';

// Ícono por estado de pago (mismo lenguaje visual que el resto de billing).
const STATUS_ICON = {
  unpaid: Clock,
  partially_paid: CircleDollarSign,
  in_review: Hourglass,
  paid: CheckCircle2,
  overdue: AlertTriangle,
  cancelled: Ban,
};

// Badge soft-pill para el estado de pago de una nota de cobro.
//
// Con `note` dibuja el estado a MOSTRAR (`displayPaymentStatus`): una nota vencida sigue
// guardada como 'unpaid' y solo billing sabe que venció. `status` queda para quien tenga
// un estado suelto sin la nota.
const PaymentStatusBadge = ({ note, status, size = 'md', withIcon = false }) => {
  const { t } = useTranslation();
  const effective = note ? displayPaymentStatus(note) : status;
  const raw = PAYMENT_STATUS_LABELS[effective] ?? effective ?? '—';
  const label = raw === '—' ? raw : t(raw);
  const tone = PAYMENT_STATUS_TONE[effective] ?? 'neutral';
  const Icon = STATUS_ICON[effective];

  return (
    <span className={`bill-badge bill-badge--${tone}${size === 'sm' ? ' bill-badge--sm' : ''}`}>
      {withIcon && Icon && <Icon className="w-3.5 h-3.5" aria-hidden />}
      {label}
    </span>
  );
};

export default PaymentStatusBadge;
